export enum BreedSize {
  XLarge = 'giant',
  Large = 'maxi',
  Medium = 'medium',
  Small = 'mini',
  XSmall = 'extra-small',
  All = 'all',
}
